import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { ChartBarData, LegendDataItem } from '../common';
import { FireflyStackedBarComponent } from '../common/bars/stacked-bar/stacked-bar.component';

@Component({
  selector: 'f-horizontal-stacked-bar-chart',
  templateUrl: './horizontal-stacked-bar-chart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireflyHorizontalStackedBarChartComponent extends FireflyStackedBarComponent {
  belowBarLabelThreshold = input(5);

  @Input() legendData: LegendDataItem[] = [];

  belowBarLabelData: ChartBarData[] = [];
  inlineLabelPercentages = new Set<number>();

  shouldDisplayBelowBarLabel(percentage: number) {
    return percentage < this.belowBarLabelThreshold();
  }

  protected override updateDerivedData() {
    super.updateDerivedData();
    this.belowBarLabelData = this.data.filter(item => this.shouldDisplayBelowBarLabel(item.percentage));
    this.inlineLabelPercentages = new Set(
      this.data.filter(item => !this.shouldDisplayBelowBarLabel(item.percentage)).map(item => item.percentage)
    );
  }
}
